import { PagesTable } from './pages-table';

export { PagesTable };
